/**
 * KAN-950: tutorial video player. When the file cannot be played (missing
 * file: nginx answers with index.html, the browser fires "error"), a short
 * note replaces the black player. Remount (key) resets the state.
 */
import { useState } from 'react';

interface TutorialVideoProps {
  src: string;
}

export function TutorialVideo({ src }: TutorialVideoProps) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <p
        role="status"
        className="flex aspect-video w-full items-center justify-center rounded-md bg-gray-100 px-4 text-center text-base text-gray-600"
      >
        Видео для этой страницы скоро появится
      </p>
    );
  }

  return (
    <video
      src={src}
      controls
      autoPlay
      playsInline
      onError={() => setFailed(true)}
      className="w-full rounded-md bg-black"
    >
      Ваш браузер не поддерживает воспроизведение видео.
    </video>
  );
}
